"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPolicyConfirmation = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const look_up_entity_1 = require("./look-up.entity");
const policy_confirmation_document_map_entity_1 = require("./policy-confirmation-document-map.entity");
let OpportunityPolicyConfirmation = class OpportunityPolicyConfirmation {
    constructor(opportunityId, activityId, opportunityActivityId, statusLid, policyDataWrongLid, deviationResolvedLid, resolutionLid, deviations, comments, policyDataRectifiedLid, remarks, createdBy, updatedBy, createdAt, updatedAt) {
        this.opportunityId = opportunityId;
        this.activityId = activityId;
        this.opportunityActivityId = opportunityActivityId;
        this.statusLid = statusLid;
        this.policyDataWrongLid = policyDataWrongLid;
        this.deviationResolvedLid = deviationResolvedLid;
        this.resolutionLid = resolutionLid;
        this.deviations = deviations;
        this.comments = comments;
        this.policyDataRectifiedLid = policyDataRectifiedLid;
        this.remarks = remarks;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
};
exports.OpportunityPolicyConfirmation = OpportunityPolicyConfirmation;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_data_wrong_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "policyDataWrongLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "deviation_resolved_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "deviationResolvedLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "resolution_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "resolutionLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "deviations",
        type: "varchar",
        length: 500,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyConfirmation.prototype, "deviations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "comments", type: "varchar", length: 500, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyConfirmation.prototype, "comments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_data_rectified_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "policyDataRectifiedLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "varchar", length: 500, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyConfirmation.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyConfirmation.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityPolicyConfirmation.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OpportunityPolicyConfirmation.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "SET NULL",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyConfirmation.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _e : Object)
], OpportunityPolicyConfirmation.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "policy_data_wrong_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _f : Object)
], OpportunityPolicyConfirmation.prototype, "policyDataWrong", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "deviation_resolved_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _g : Object)
], OpportunityPolicyConfirmation.prototype, "deviationResolved", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "resolution_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _h : Object)
], OpportunityPolicyConfirmation.prototype, "resolution", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "policy_data_rectified_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_j = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _j : Object)
], OpportunityPolicyConfirmation.prototype, "policyDataRectified", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_confirmation_document_map_entity_1.PolicyConfirmationDocumentMap, (documentMap) => documentMap.policyConfirmation, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityPolicyConfirmation.prototype, "documents", void 0);
exports.OpportunityPolicyConfirmation = OpportunityPolicyConfirmation = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_policy_confirmation"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number, Number, Number, String, String, Number, String, Number, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object])
], OpportunityPolicyConfirmation);
